module.exports = __webpack_public_path__ + "static/media/telephone.d02c74c9.svg";